/**
 * TanStack Query Client Configuration
 * Centralized query client with default options, retry logic, and cache config
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (garbage collection)
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
